module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/summer-bg-ace8b56869dcabbf7f241eaca6d071ea.png";